import actionsTypes from 'store/actionTypes';

export const loadUserConfigs = () => ({
  type: actionsTypes.LOAD_CONFIGS,
});
